import React, { useState,useEffect, use } from 'react';
import { Link } from 'react-router-dom';
import  getProjects  from '../../ApiSeervice';

const Project = () => {

// const [projects, setProjects] = useState([]);
// useEffect(() => {
//     async function getProjectss() {

//             const response = await getProjects();
//             setProjects(response);
//             console.log("ateşe düştüm",response);
//         }
//         getProjectss();

//     }, []);

    const [data] = useState([
        {
            id: 1,
            srcimg: 'http://3.73.248.105:3132/public/1000026460.jpg', 
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 2,
            srcimg: 'assets/img/project/project-2-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 3,
            srcimg: 'assets/img/project/project-3-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 4,
            srcimg: 'assets/img/project/project-4-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 5,
            srcimg: 'assets/img/project/project-1-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 6,
            srcimg: 'assets/img/project/project-2-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 7,
            srcimg: 'assets/img/project/project-3-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        },
        {
            id: 8,
            srcimg: 'assets/img/project/project-4-440x280.jpg',
            heading: 'LAKE MEADOWS APARTMENTS',
            meta: 'Architecture',
            text: 'Building'
        }
    ]);

    return (
        <div className="themesflat-carousel-box clearfix" data-gap={30} data-column={4} data-column2={2} data-column3={1} data-auto="false">
            <div className="owl-carousel owl-theme">
                {data.map(item => (
                    <div className="themesflat-project style-1 data-effect clearfix" key={item.id}>
                        <div className="project-item">
                            <div className="inner">
                                <div className="thumb data-effect-item has-effect-icon w40 offset-v-43 offset-h-46">
                                    <img src={item.srcimg} style={{width:"25vw",height:"22.5vh",objectFit:"cover"}} alt="altimage" />
                                    <div className="text-wrap text-center">
                                        <h5 className="heading"><Link to="#">{item.title}</Link></h5>
                                        {/* <div className="elm-meta">
                                            <span><Link to="#">{item.meta}</Link></span>
                                            <span><Link to="#">{item.text}</Link></span>
                                        </div> */}
                                    </div>
                                    {/* <div className="elm-link">
                                        <Link to="#" className="icon-1 icon-search"></Link>
                                        <Link to="#" className="icon-1"></Link>
                                    </div> */}
                                    <div className="overlay-effect bg-color-3" />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Project;
